<template>
    <select
        v-model="model"
        v-bind="$attrs"
        :disabled="isDisabled"
    >
        <option
            v-for="(item, i) in items"
            :key="getKey ? getKey(item) : i"
            :value="item"
        >
            {{ getDisplayText(item) }}
        </option>
    </select>
</template>

<script setup lang="ts" generic="T">
import { PropType } from 'vue';

const model = defineModel<T | null>({ default: null });

defineOptions({ inheritAttrs: false });

defineProps({
    items: { type: Array as PropType<T[]>, required: true },
    getDisplayText: { type: Function as PropType<(item: T) => string>, required: true },
    getKey: { type: Function as PropType<(item: T) => string | number>, required: false },
    isDisabled: { type: Boolean, default: false }
});
</script>
